import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { useRef} from "react";
import Slider from "react-slick";

export default function HomeTeam() {
    const sliderRef = useRef(null);
    
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        cssEase: "ease",
        draggable: false,   
        swipe: false, 
        responsive: [
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2 },
        },
        ],
    };

  return (
    <>
    <div className="home-team">
        <div className="container">
            <div className="row justify-content-center">  

                <div className="col-lg-12">
                    <div className="hometeam-head">
                        <h4 className="heading">Our Team</h4>
                        {/* <Link to="" className="arrow-button">Meet The Team <Icons name="Longarrow_right"/></Link> */}
                    </div> 
                </div>

                <div className="col-lg-10">
                    <Tab.Container defaultActiveKey="year-tab1">
                        <Nav className="teamtab-link">
                            <Nav.Item>
                                <Nav.Link eventKey="year-tab1">Founding Members</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="year-tab2">Planning</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="year-tab3">Design</Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content className="yearstab-content">
                            <Tab.Pane eventKey="year-tab1">
                                <p className="teamslider-title">Showcasing the Masterminds Behind Saysha</p>

                                <Slider {...settings} ref={sliderRef} className="team-slider">
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Jitender Juneja</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div> */}

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-2.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Umesh Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-2.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div> */}

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-3.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Mukesh Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-3.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div> */}

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-4.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Manoj Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-4.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div> */}
                                </Slider>
                            </Tab.Pane>

                            <Tab.Pane eventKey="year-tab2">
                                <p className="teamslider-title">Design With A Distinct Point of View</p>

                                <Slider {...settings} ref={sliderRef} className="team-slider">
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Jitender Juneja</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-2.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Umesh Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-2.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-3.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Mukesh Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-3.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-4.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Manoj Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-4.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div>
                                </Slider>
                            </Tab.Pane>

                            <Tab.Pane eventKey="year-tab3">
                                <p className="teamslider-title">Design With A Distinct Point of View</p>

                                <Slider {...settings} ref={sliderRef} className="team-slider">
                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Jitender Juneja</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div> */}
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div>

                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-2.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Umesh Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div> */}
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-2.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div>

                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-3.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Mukesh Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div> */}
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-3.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div>

                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-4.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Manoj Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div> */}
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-4.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div>
                                </Slider>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>

            </div>
        </div>
    </div> 
    </>
  )
}
